export default "__VITE_ASSET__CNmctQh$__"